import React from 'react'

import TextEditor, { TEXT_EDITOR_MODES } from 'components/TextEditor/TextEditor'
import { BUTTON_POSITIONS } from '../../schema'

/**
 * CTA button
 */
class Button extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            html: props.text,
            focused: false,
        }
    }

    render() {
        const {
            blockData: { t, text, id, brad, bc, position },
            onUpdate,
        } = this.props

        const blockStyles = {
            textAlign: 'center',
        }
        if (position === BUTTON_POSITIONS.LEFT) blockStyles.textAlign = 'left'
        if (position === BUTTON_POSITIONS.CENTER) blockStyles.textAlign = 'center'
        if (position === BUTTON_POSITIONS.RIGHT) blockStyles.textAlign = 'right'

        const buttonStyles = {
            borderRadius: brad + 'px',
            backgroundColor: bc,
        }

        return (
            <div className={`block __${t}`} style={blockStyles}>
                <div className="rbtn" style={buttonStyles}>
                    <TextEditor
                        id={id}
                        content={text}
                        propName={'text'}
                        mode={TEXT_EDITOR_MODES.BUTTON}
                        onChange={html => {
                            onUpdate({
                                [id]: {
                                    data: { text: html },
                                },
                            })
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default Button
